<script>
    import { Table, Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'sveltestrap';
    import http from '../api/http';
    import { selectedGroup } from '../store';
    import formatDate from '../Helpers/DateTimeFormatter';

    let Shown =false;
    const toggle = () => (Shown = !Shown);
    let ObjectId = 0;
    export let Mode;
    let CommandType;
    let DeploymentHistory;
    let CommandHistory;
    let SoftwareHistory;

    $: { 
        ObjectId; 
      if (ObjectId != 0){
        if(Mode == "Deployment"){
            getDeploymentHistory();
        }
        if(Mode == "Command"){
            getCommandHistory();
        }
        if(Mode == "Software"){
            getSoftwareHistory();
        }
      }     
  }

    async function getDeploymentHistory(){
        if(ObjectId != 0){
            const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/deployments/${ObjectId}/${$selectedGroup}/history`);
            DeploymentHistory = await res.json();
        }
    }

    async function getCommandHistory(){
      var url;
      
      if(CommandType == "Installation")
      {
        url = `/deploy/dashboard/installations/${ObjectId}/${$selectedGroup}/history`;
      }
      else
      {
        url = `/deploy/dashboard/datatransfer/${ObjectId}/${$selectedGroup}/history`;
      }
        const res = await http.get(window.apiBaseUrl + url);
        CommandHistory = await res.json();        
    }

    async function getSoftwareHistory(){
        const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/software/${ObjectId}/${$selectedGroup}/history`);
        SoftwareHistory = await res.json();                
    }

    export async function show(id, mode, commandType) { 
        ObjectId = id;
        Mode = mode;
        CommandType = commandType;
        Shown = true;
    }

    function getDeploymentStatus(status){
    var retval;
    if (status == 1){
    retval = "Cancelled"
    }
    if (status == 2){
    retval = "Pending"
    }    
    if (status == 3){
    retval = "Building Deployment"
    }
    if (status == 4){
    retval = "Deploying"
    }
    if (status == 5){
    retval = "Deployed"
    }
    if (status == 6){
    retval = "Failed"
    }
    if (status == 7){
    retval = "Awaiting Collection"
    }
    if (status == 8){
    retval = "Downloading"
    }
    if (status == 9){
    retval = "Cataloguing"
    }
    if (status == 10){
    retval = "Upload Failure"
    }

    return retval;
  }

  function getCommandStatus(status){
       var retval;       
       if (status == 1)
       {
         retval = "Cancelled"
       }
       else if (status == 2)
       {
         retval = "Waiting"
       }    
       else if (status == 3)
       {
         retval = "Pending"
       }
       else if (status == 4)
       {
        retval = "CreatingCommand"
       }
       else if (status == 5)
       {
         retval = "In Progress"
       }
       else if (status == 6)
       {                
        retval = "Complete"        
       }
       else if (status == 7)
       {
         retval = "Failed"
       }
       else if (status == 8)
       {  
         retval = "Complete with Errors"
       }
       else if (status == 9){         
          retval = "Awaiting Collection"
       }       
       else if (status == 10){         
          retval = "Awaiting Deployment Completion"
       }       
	   	else if (status == 11){
			retval = "Downloading"
       	}
		else if (status == 12){
			retval = "Cataloguing"
       	}
		else if (status == 13){
        	retval = "Upload Failure"
		}

       return retval;
     }
     function getSoftwareStatus(status){
       var retval;
       if (status == 1){
         retval = "Pending Build"
       }
       if (status == 2){
         retval = "Building"
       }    
       if (status == 3){
         retval = "Ready"
       }
       if (status == 4){
         retval = "Failed"
       }
       if (status == 5){
         retval = "Deleted"
       }
       if (status == 5){
         retval = "Deleted"
       }
       if (status == 6){
         retval = "Awaiting Version Number"
       }
       return retval;
     }

</script>
<style>

</style>

<Modal size='lg' isOpen={Shown} {toggle}>
    <ModalHeader {toggle}>
        View {Mode} History
    </ModalHeader>
    <ModalBody>
        <Table responsive id="{Mode}StateTable">     
            <thead>
                <tr>
                    <th>State</th>
                    <th>User</th>
                    <th>Date</th>
                    <th>Machine</th>
                </tr>
            </thead>
            <tbody>
                {#if Mode == "Deployment" && DeploymentHistory != undefined && DeploymentHistory.length > 0}
                    {#each DeploymentHistory as Deployment}
                        <tr>
                            <td>{getDeploymentStatus(Deployment.status)} </td>
                            <td>{Deployment.alteredBy} </td>
                            <td>{formatDate(Deployment.created)} </td>
                            <td>{Deployment.remoteMachine} </td>
                        </tr>
                    {/each}
                {/if}
                {#if Mode == "Command" && CommandHistory != undefined}
                    {#each CommandHistory as Command}
                        <tr>
                            <td>{getCommandStatus(Command.status)} </td>
                            <td>{Command.alteredBy} </td>
                            <td>{formatDate(Command.created)} </td>
                            <td>{Command.remoteMachine} </td>
                        </tr>
                    {/each}
                {/if}
                {#if Mode == "Software" && SoftwareHistory != undefined}
                    {#each SoftwareHistory as Software}
                        <tr>
                            <td>{getSoftwareStatus(Software.status)} </td>
                            <td>{Software.alteredBy} </td>
                            <td>{formatDate(Software.created)}</td>
                            <td>{Software.remoteMachine} </td>
                        </tr>
                    {/each}
                {/if}        
            </tbody>
        </Table>        
    </ModalBody>
    <ModalFooter> 
        <button class="btn btn-outline-primary" on:click={toggle}>Close</button>
    </ModalFooter>
</Modal>





